import styled from "styled-components";

export const PreviewScrollStyled = styled.div`
  max-height: 75vh;
  overflow-y: auto;
  text-align: center;
`;
